<style lang="less">
  @import "~@/public/less/index.less";
  .fan-table{
    width: 100%;
    .table-toolbar{
      display: flex;
      justify-content: space-between;
      align-items: center;
      margin-bottom: 12px;
      .toolbar-left{
        display: flex;
        align-items: center;
        gap: 10px;
      }
      .toolbar-right{
        display: flex;
        align-items: center;
        gap: 10px;
      }
    }
    .arco-table{
      width: 100%;
      table{ width: 100%; }
    }
    .arco-spin{ width: 100%; }
    .density-list{
      min-width: 80px;
      font-size: 13px;
      div{ padding: 6px 12px; cursor: pointer;
        &:hover{ background-color: var(--color-fill-2); }
        &.active{ color: rgb(var(--primary-6)); font-weight: 500; }
      }
    }
    .action-btn-group {
      display: inline-flex;
      align-items: center;
      border: 1px solid #e5e6eb;
      border-radius: 5px;
      overflow: hidden;
      .action-btn {
        display: inline-flex;
        align-items: center;
        justify-content: center;
        width: 24px;
        height: 24px;
        color: #4e5969;
        cursor: pointer;
        transition: all 0.2s;
        // 给按钮之间加分割线，模拟按钮组效果
        &:not(:last-child) {
          border-right: 1px solid #e5e6eb;
        }
        &:hover {
          color: #1677ff;
          background-color: #f2f3f5;
        }
      }
      .delete-btn {
        background-color: #f53f3f;
        color: #fff;
        &:hover {
          color: #fff;
          background-color: #f9695e;
        }
      }
      .other-btn {
        background-color: #186df6 !important;
        color: #fff !important;
        &:hover {
          color: #fff !important;
          background-color: #5185f5 !important;
        }
        .arco-icon {
          color: inherit !important;
        }
      }
    }
    .table-images-wrap {
      display: flex; gap: 4px; align-items: center; flex-wrap: nowrap;
    }
    .image-more-count {
      display: inline-flex; align-items: center; justify-content: center;
      min-width: 40px; height: 40px; padding: 0 4px;
      font-size: 12px; color: #86909c;
      background: var(--color-fill-2); border-radius: 4px;
    }
    .arco-table .arco-image { background: transparent; }
  }
</style>

<template>
  <div class="fan fan-component fan-table">
    <!-- 表格工具栏 -->
    <div class="table-toolbar" v-if="showToolbar">
      <div class="toolbar-left">
        <slot name="toolbarLeft"></slot>
      </div>
      <div class="toolbar-right">
        <a-tooltip content="刷新">
          <div size="small" @click="$emit('reloadData')"><icon-refresh size="18"/></div>
        </a-tooltip>
        <a-popover trigger="click" position="bottom">
        <a-tooltip content="密度">
          <div size="small"><icon-line-height size="18"/></div>
        </a-tooltip>
          
          <template #content>
            <div class="density-list">
              <div v-for="item in densityList" :key="item.key"
                   :style="{ padding: '6px 12px', cursor: 'pointer', fontWeight: tableSize === item.key ? 500 : 400, color: tableSize === item.key ? 'rgb(var(--primary-6))': '' }"
                   @click="tableSize = item.key"
                   @mouseenter="$event.target.style.backgroundColor = 'var(--color-fill-2)'"
                   @mouseleave="$event.target.style.backgroundColor = ''">
                {{ item.label }}
              </div>
            </div>
          </template>
        </a-popover>
        <a-popover trigger="click" position="bottom">
          <a-tooltip content="列设置">
            <div size="small"><icon-settings size="18"/></div>
          </a-tooltip>
          <template #content>
            <div class="col-setting-list">
              <div v-for="(col, index) in allColumns" :key="(col.dataIndex || col.key || col.title) + '_' + index"
                   :draggable="true"
                   :style="{ padding: '6px 8px', display: 'flex', alignItems: 'center', cursor: 'grab',
                     opacity: dragIndex === index ? 0.4 : 1,
                     borderTop: index > 0 && dropIndex === index ? '2px solid rgb(var(--primary-6))' : '',
                     borderBottom: dropIndex === index + 1 ? '2px solid rgb(var(--primary-6))' : '' }"
                   @click="bindToggleColumn(col.key === 'action' ? '__action__' : (col.dataIndex || col.key || col.title))"
                   @dragstart="bindDragStart($event, index)"
                   @dragenter.prevent="bindDragEnter($event, index)"
                   @dragend="bindDragEnd"
                   @dragover.prevent>
                <icon-drag-dot style="cursor: grab; color: #c0c4cc; margin-right: 6px;" />
                <span style="width: 18px; text-align: center; margin-right: 6px; font-size: 14px;">
                  {{ colVisibleMap[col.key === 'action' ? '__action__' : (col.dataIndex || col.key || col.title)] === false ? '□' : '☑' }}
                </span>
                <span>{{ col.title || col.dataIndex || col.key || '操作' }}</span>
              </div>
            </div>
            <div style="text-align: center; padding-top: 8px; border-top: 1px solid #e5e6eb; font-size: 12px; color: #86909c;">
              拖拽左侧图标可调整列顺序
            </div>
          </template>
        </a-popover>
        <a-tooltip content="导出数据" v-if="allowExport">
          <a-button size="small" type="primary" status="success" @click="bindExport"><icon-download />导出</a-button>
        </a-tooltip>
        <slot name="toolbarRight"></slot>
      </div>
    </div>
    <a-spin :loading="superLoading"  tip="加载中..." >
      <div v-if="tableColumns.length === 0" style="padding: 20px; text-align: center; color: #999;">
        <span>没有可显示的列（所有列可能被隐藏或未定义）</span>
        <div>superColumns长度: {{superColumns?.length}}</div>
        <div>tableData长度: {{tableData.length}}</div>
      </div>
      <a-table v-else
          :columns="tableColumns"
          :data="tableData"
          :bordered="{ cell: true }"
          :size="tableSize"
          :pagination="false"
          row-key="id"
          @change="bindTableChange"
        >
        <template #bool="{ record, column }">
          <a-switch :model-value="record[column.dataIndex]" disabled/>
        </template>
        <template #__index__="{ rowIndex }">
          {{ rowIndex + 1 }}
        </template>
        <template #image="{ record, column }">
          <a-image v-if="record[column.dataIndex]"
                   width="48"
                   height="48"
                   :src="record[column.dataIndex]"
                   fit="cover"
                   style="border-radius: 6px; cursor: pointer;"
          />
          <span v-else style="color:#c0c4cc;">-</span>
        </template>
        <template #icon="{ record, column }">
          <template v-if="record[column.dataIndex]">
            <svg-icon v-if="String(record[column.dataIndex]).startsWith('svg-')" :name="String(record[column.dataIndex]).slice(4)" size="18" />
            <component v-else :is="'icon-' + String(record[column.dataIndex]).replace(/^icon-/, '')" style="font-size:18px" />
          </template>
          <span v-else style="color:#c0c4cc;">-</span>
        </template>
        <template #mapPoint="{ record, column }">
          <a-popover v-if="record[column.dataIndex]" position="left" :content-style="{ padding: 0 }">
            <template #content><img style="max-width: 400px; max-height: 400px;" :src="'http://api.map.baidu.com/staticimage/v2?ak=R2eTZTK1CIATNfGZSSLu5IdYodrCKrcq&mcode=666666&center='+ record[column.dataIndex].x+','+record[column.dataIndex].y+ '&markers='+record[column.dataIndex].x+','+record[column.dataIndex].y+ '&width=450&height=300&zoom=18&dpiType=pl'" /></template>
            <a href="javascript:void(0)" style="display: block; height: 60px;">
              <img style="max-width: 300px; max-height: 60px;" :src="'http://api.map.baidu.com/staticimage/v2?ak=R2eTZTK1CIATNfGZSSLu5IdYodrCKrcq&mcode=666666&center='+ record[column.dataIndex].x+','+record[column.dataIndex].y+ '&markers='+record[column.dataIndex].x+','+record[column.dataIndex].y+ '&width=450&height=300&zoom=18&dpiType=pl'" />
            </a>
          </a-popover>
          <span v-else>暂无数据</span>
        </template>
        <template #file="{ record, column }">
          <a-button v-if="record[column.dataIndex]" size="small" @click="bindDownload(record[column.dataIndex])"><icon-download />下载</a-button>
          <span v-else>暂无数据</span>
        </template>
        <!-- 操作列插槽 -->
        <template #action="{ record }">
          <slot name="action" :record="record">
            <!-- 自己写的按钮组容器，不用Arco的组件 -->
            <div class="action-btn-group">
              <!-- 查看 -->
              <a-tooltip content="查看">
                <div class="action-btn" @click="$emit('view', record)">
                  <icon-eye />
                </div>
              </a-tooltip>

              <!-- 编辑 -->
              <a-tooltip content="编辑">
                <div class="action-btn" @click="$emit('edit', record)">
                  <icon-edit />
                </div>
              </a-tooltip>

              <!-- 删除 -->
              <a-popconfirm content="确定要删除这条记录吗？" @ok="$emit('delete', { record })">
                <a-tooltip content="删除">
                  <div class="action-btn delete-btn">
                    <icon-delete />
                  </div>
                </a-tooltip>
              </a-popconfirm>
            </div>
          </slot>
        </template>
        <!-- 自定义操作列插槽 -->
        <template #actions="{ record }">
          <slot name="actions" :record="record">
            <a-button-group>
              <a-tooltip content="查看">
                <div class="action-btn" @click="$parent.$refs.flayout.bindOpenCurd('详情', record)" >{{ record.name }}<icon-eye /></div>
              </a-tooltip>
              <a-tooltip content="编辑"><div class="action-btn" @click="$parent.$refs.flayout.bindOpenCurd('编辑', record)"><icon-edit /></div></a-tooltip>
              <a-popconfirm content="确定要删除这条记录吗？" @ok="$parent.bindDeleteRecord({record: record})">
                <a-tooltip content="删除"><div class="action-btn delete-btn"><icon-delete /></div></a-tooltip>
              </a-popconfirm>
            </a-button-group>
          </slot>
        </template>
        <template #esign="{ record, column }">
          <a-image v-if="record[column.dataIndex]"
                   width="48" height="48"
                   :src="record[column.dataIndex]" fit="cover"
                   style="border-radius: 6px; cursor: pointer;"
          />
          <span v-else style="color:#c0c4cc;">-</span>
        </template>
        <template #esignbm="{ record, column }">
          <a-image v-if="record[column.dataIndex]"
                   width="48" height="48"
                   :src="record[column.dataIndex]" fit="cover"
                   style="border-radius: 6px; cursor: pointer;"
          />
          <span v-else style="color:#c0c4cc;">-</span>
        </template>
        <template #images="{ record, column }">
          <div v-if="parseImageUrls(record[column.dataIndex]).length" class="table-images-wrap">
            <template v-for="(url, idx) in parseImageUrls(record[column.dataIndex])" :key="idx">
              <a-image
                v-if="idx < 4"
                width="40"
                height="40"
                :src="url"
                fit="cover"
                style="border-radius: 4px; cursor: pointer;"
              />
            </template>
            <span v-if="parseImageUrls(record[column.dataIndex]).length > 4" class="image-more-count">
              +{{ parseImageUrls(record[column.dataIndex]).length - 4 }}
            </span>
          </div>
          <span v-else style="color:#c0c4cc;">-</span>
        </template>
        <template #imagebm="{ record, column }">
          <a-image v-if="record[column.dataIndex]"
                   width="48" height="48"
                   :src="record[column.dataIndex]" fit="cover"
                   style="border-radius: 6px; cursor: pointer;"
          />
          <span v-else style="color:#c0c4cc;">-</span>
        </template>
        <template #editor="{ record, column }">
          <a-tooltip v-if="record[column.dataIndex]" :content="stripHtml(record[column.dataIndex])" position="tl">
            <span style="display:inline-block;max-width:200px;overflow:hidden;text-overflow:ellipsis;white-space:nowrap;vertical-align:middle;">{{ stripHtml(record[column.dataIndex]) }}</span>
          </a-tooltip>
          <span v-else style="color:#c0c4cc;">-</span>
        </template>
        <template #option="{ record, column }">
          <template v-if="record[column.dataIndex] || record[column.dataIndex]===0">
            <!-- 兼容逗号分隔的多值（如 spid 可能存 "1,2,3"） -->
            <template v-if="String(record[column.dataIndex]).indexOf(',') > 0">
              <a-tag v-for="(item, idx) in String(record[column.dataIndex]).split(',').map(s=>s.trim()).filter(Boolean)" :key="idx" size="small">
                {{ getOptionName(column.dataIndex, item) }}
              </a-tag>
            </template>
            <!-- 单值正常显示 -->
            <span v-else>{{ getOptionName(column.dataIndex, record[column.dataIndex]) }}</span>
          </template>
          <span v-else style="color:#999">-</span>
        </template>
        <template #apply_states="{ record, column }">
          <a-tag v-if="record[column.dataIndex]===0" color="oranged" size="small">待审</a-tag>
          <a-tag v-else-if="record[column.dataIndex]===1" color="blue" size="small">复核</a-tag>
          <a-tag v-else-if="record[column.dataIndex]===2" color="green" size="small">批准</a-tag>
          <a-tag v-else-if="record[column.dataIndex]===3" color="red" size="small">驳回</a-tag>
          <a-tag v-else-if="record[column.dataIndex]===5" color="cyan" size="small">验收</a-tag>
          <span v-else style="color:#c0c4cc">未知({{record[column.dataIndex]}})</span>
        </template>
      </a-table>
      <!-- 分页组件 -->
      <div v-if="!hidePagination" style="margin-top: 16px; text-align: right;">
        <a-pagination
          v-if="superData"
          :total="totalCount"
          :page-size="superFilter.limit || 10"
          :current="superFilter.page || 1"
          :page-size-options="[10, 20, 30, 50]"
          show-total
          show-page-size
          @change="bindPageChange"
          @page-size-change="bindSizeChange"
        />
      </div>
    </a-spin>
  </div>
</template>

<script>

import moment from 'moment'

const DENSITY_LIST = [
  { key: 'mini', label: '迷你' },
  { key: 'small', label: '紧凑' },
  { key: 'medium', label: '中等' },
  { key: 'large', label: '宽松' }
]

export default {
  name: 'FTable',
  // components: { IconEye, IconEdit, IconDelete, IconDownload, IconRefresh, IconSettings, IconCheck, IconLineHeight, IconDragDot },
  emits: ['change', 'view', 'edit', 'delete', 'refresh', 'export', 'reloadData'],
  props: {
    superLoading: Boolean,
    superData: Object,
    superColumns: Array,
    superFilter: Object,
    superKeyinfo: Object, // 页面级传入的keyinfo（优先使用）
    showToolbar: { type: Boolean, default: true },
    allowExport: { type: Boolean, default: true },
    hidePagination: { type: Boolean, default: false }
  },
  data() {
    return {
      tableSize: 'medium',
      colVisibleMap: {},    // { dataIndex: true/false }
      colOrder: [],         // 自定义列顺序 [dataIndex, ...]
      dragIndex: -1,        // 拖拽中的行索引
      dropIndex: -1,         // 放置目标位置
      isDragging: false      // 是否正在拖拽（防止 dragend 后误触 click）
    }
  },
  computed: {
    tableColumns() {
      if (!this.superColumns) return []
      // 按 colOrder 排序
      let cols = this.superColumns.map(c => ({...c}))
      if (this.colOrder.length > 0) {
        const orderMap = {}
        this.colOrder.forEach((k, i) => orderMap[k] = i)
        cols = cols.sort((a, b) => {
          const ak = a.key === 'action' ? '__action__' : (a.dataIndex || a.key || a.title)
          const bk = b.key === 'action' ? '__action__' : (b.dataIndex || b.key || b.title)
          return (orderMap[ak] ?? 999) - (orderMap[bk] ?? 999)
        })
      }
      const columns = []
      // 自动添加序号列（如果未传入）
      const hasIndex = cols.some(c => c.dataIndex === 'xh' || c.title === '序号')
      if (!hasIndex) {
        columns.push({
          title: '序号', dataIndex: '__index__', key: '___index___', width: 90, align: 'center',
          slotName: '__index__'
        })
      }
      cols.forEach((column, idx) => {
        const col = {...column}
        if (col.hidden && col.hidden.indexOf('list') >= 0) return
        if (!col.dataIndex) {
          col.dataIndex = col.key || col.title
        }
        // ★ 强制确保每列都有唯一 key（消除 "Duplicate keys found: arco-col-template" 警告）
        if (!col.key) {
          col.key = `__col_${col.dataIndex}_${idx}__`
        }
        // 操作列单独判断
        const mapKey = col.key === 'action' ? '__action__' : (col.dataIndex || col.key || col.title)
        if (this.colVisibleMap[mapKey] === false) return
        if (col.key === 'action' || column.key === 'action') {
          col.slotName = 'action'
        } else {
          // 按优先级判断 slotName：scopedSlots > form > slot/key
          const renderSlot = col.scopedSlots?.customRender || col.form
          if (renderSlot && ['bool','switch','image','images','mapPoint','file','esign','esignbm','imagebm','editor','apply_states','icon'].includes(renderSlot)) {
            col.slotName = renderSlot
          } else if (['radio','select','cascader','selectTree','linkSelect','selectMultiple'].includes(col.form) || col.customRender) {
            col.slotName = 'option'
          }
        }
        // 单位后缀列：直接用 Arco render，不走 option 槽位
        if (!col.slotName && col.unit && !col.customRender) {
          const _ut = col.unit
          const _uf = col.dataIndex
          col.render = ({ record }) => {
            const v = record[_uf]
            if (v == null || v === '') return '-'
            return v + ' ' + _ut
          }
        }
        // numberWithUnit：显示数字+单位名称
        if (!col.slotName && col.form === 'numberWithUnit') {
          const _nf = col.dataIndex
          const _uf = col.unitField || (col.dataIndex + '_unit')
          const vm = this
          col.render = ({ record }) => {
            const num = record[_nf]
            const uid = record[_uf]
            let unitName = ''
            if (uid != null && uid !== '') {
              const ki = vm.$store?.state?.page?.keyinfo || {}
              const info = ki[_uf] && ki[_uf][uid]
              if (info) unitName = info.name
            }
            if (num == null || num === '') return unitName || '-'
            return unitName ? num + ' ' + unitName : String(num)
          }
        }
        // 日期类列：表格中按列类型格式化显示（避免直接显示原始完整日期）
        if (!col.slotName && !col.render && ['datepicker', 'monthpicker', 'yearpicker', 'quarterpicker', 'datetimepicker', 'weekpicker'].indexOf(col.form) > -1) {
          const fmtMap = { datepicker: 'YYYY-MM-DD', monthpicker: 'YYYY-MM', yearpicker: 'YYYY', quarterpicker: 'YYYY-[Q]Q', datetimepicker: 'YYYY-MM-DD HH:mm:ss', weekpicker: 'YYYY-WW' }
          const fmt = fmtMap[col.form] || 'YYYY-MM-DD'
          const _f = col.dataIndex
          col.render = ({ record }) => {
            const v = record[_f]
            if (v === null || v === undefined || v === '') return '-'
            const m = moment(v)
            return m.isValid() ? m.format(fmt) : String(v)
          }
        }
        columns.push(col)
      })
      return columns
    },
    tableData() {
      const data = this.superData
      // 兼容 { data: [...] } 和 { data: { data: [...] } } 两种结构
      const arr = data?.data
      if (Array.isArray(arr)) return arr
      if (arr && Array.isArray(arr.data)) return arr.data
      return []
    },
    totalCount() {
      const data = this.superData
      if (!data) return 0
      return Number(data.total || data.count || data.data?.count || data.data?.total || 0)
    },
    allColumns() {
      // 列设置面板：包含所有可控制列 + 操作列
      if (!this.superColumns) return []
      const cols = this.superColumns.filter(col => (!col.hidden || col.hidden.indexOf('list') < 0))
      // 首次加载时初始化 colOrder
      if (this.colOrder.length === 0 && cols.length > 0) {
        this.colOrder = cols.map(c => c.key === 'action' ? '__action__' : (c.dataIndex || c.key || c.title))
      }
      // 按 colOrder 排序（操作列始终放最后）
      if (this.colOrder.length > 0) {
        const orderMap = {}
        this.colOrder.forEach((k, i) => orderMap[k] = i)
        const sorted = [...cols].sort((a, b) => {
          const ak = a.key === 'action' ? '__action__' : (a.dataIndex || a.key || a.title)
          const bk = b.key === 'action' ? '__action__' : (b.dataIndex || b.key || b.title)
          return (orderMap[ak] ?? 999) - (orderMap[bk] ?? 999)
        })
        return sorted
      }
      return cols
    },
    densityList() {
      return DENSITY_LIST
    }
  },
  methods: {
    stripHtml(html) {
      if (!html) return ''
      const div = document.createElement('div')
      div.innerHTML = html
      return div.textContent || div.innerText || ''
    },
    parseImageUrls(val) {
      // 兼容多种数据格式：数组、JSON字符串、单个URL字符串
      if (Array.isArray(val)) return val.filter(v => v && (typeof v === 'string'))
      if (!val) return []
      if (typeof val === 'string') {
        if (val.indexOf('http') === 0) return [val] // 纯URL字符串
        try {
          const parsed = JSON.parse(val)
          return Array.isArray(parsed) ? parsed.filter(v => v) : []
        } catch { return [] }
      }
      return []
    },
    getOptionName(key, val, pix=' - ') {
      if (val === null || val === undefined || val === '') return `-`
      // 优先用页面级prop传入的keyinfo
      const options = (this.superKeyinfo && Object.keys(this.superKeyinfo).length > 0)
        ? this.superKeyinfo
        : (this.$store.state.page?.keyinfo || {})
      // keyinfo 整体未就绪 或 当前字段无映射 → 显示占位符（不闪ID）
      if (!options || !Object.keys(options).length || !options[key]) {
        return '-'
      }
      const optMap = options[key]

      /* 匹配策略1: 精确匹配（val 直接作为 key） */
      if (optMap[val] && optMap[val].name) return optMap[val].name

      /* 匹配策略2: Number 转换后精确匹配（"42" → 42） */
      const numVal = Number(val)
      if (!isNaN(numVal) && numVal !== val && optMap[numVal] && optMap[numVal].name) return optMap[numVal].name

      /* 匹配策略3: String(val) 作为 key 查找 */
      const strVal = String(val)
      if (optMap[strVal] && optMap[strVal].name) return optMap[strVal].name

      /* 匹配策略4: 遍历所有 key 做 String() 比较（最兜底） */
      for (const k of Object.keys(optMap)) {
        if (String(k) === strVal && optMap[k].name) return optMap[k].name
      }

      /* 匹配策略5: value 字段匹配（兼容带 value 的格式） */
      for (const k in optMap) {
        if (optMap[k] !== null && typeof optMap[k] === 'object' && optMap[k].value !== undefined && String(optMap[k].value) === strVal) {
          return optMap[k].name
        }
      }

      /* 全部失败，返回原始值 */
      return String(val)
    },
    bindTableChange (pagination, filters, sorter) {
      this.$emit('change', pagination, filters, sorter)
    },
    bindDownload (file) {
      window.open(file)
    },
    // 分页变化
    bindPageChange (page) {
      // console.log('bindPageChange called:', page)
      this.$emit('change', { current: page, pageSize: this.superFilter.limit || 10 }, {}, {})
    },
    // 每页显示条数变化
    bindSizeChange (size) {
      // console.log('bindSizeChange called:', size)
      this.$emit('change', { current: this.superFilter.page || 1, pageSize: size }, {}, {})
    },
    // 切换列显示
    bindToggleColumn(dataIndex) {
      if (this.isDragging) { this.isDragging = false; return }
      const current = this.colVisibleMap[dataIndex] === false
      this.colVisibleMap = { ...this.colVisibleMap, [dataIndex]: current }
    },
    // 拖拽开始
    bindDragStart(e, index) {
      this.isDragging = true
      this.dragIndex = index
      e.dataTransfer.effectAllowed = 'move'
      e.dataTransfer.setData('text', String(index))
    },
    // 拖拽进入目标
    bindDragEnter(e, index) {
      if (this.dragIndex !== -1 && this.dragIndex !== index) {
        this.dropIndex = index
      }
    },
    // 拖拽结束，执行排序
    bindDragEnd() {
      if (this.dragIndex !== -1 && this.dropIndex !== -1 && this.dragIndex !== this.dropIndex) {
        // 重新排列 colOrder
        const newOrder = [...this.colOrder]
        const [moved] = newOrder.splice(this.dragIndex, 1)
        newOrder.splice(this.dropIndex, 0, moved)
        this.colOrder = newOrder
      }
      this.dragIndex = -1
      this.dropIndex = -1
      // 延迟重置 isDragging，让 click 事件有机会检测到它
      setTimeout(() => { this.isDragging = false }, 100)
    },
    // 导出数据
    bindExport() {
      const data = this.tableData
      if (!data || data.length === 0) return
      // 获取可见列（排除操作列）
      const visibleCols = this.tableColumns.filter(c => !c.hidden && c.dataIndex !== 'action')
      // 构建表头和内容（选项类列用 keyinfo 转 id → name）
      const headers = visibleCols.map(c => c.title || c.dataIndex)
      const rows = data.map(row => visibleCols.map(c => {
        const val = row[c.dataIndex] ?? ''
        // 选项列：用 keyinfo 把 id 转为 name
        if (['radio', 'select', 'cascader', 'selectTree', 'linkSelect'].includes(c.form) || c.customRender) {
          return this.getOptionName(c.dataIndex, val)
        }
        return val
      }))
      // 生成 CSV
      let csv = '\uFEFF' // BOM for UTF-8
      csv += headers.map(h => `"${(h + '').replace(/"/g, '""')}"`).join(',') + '\n'
      rows.forEach(row => {
        csv += row.map(cell => `"${(cell + '').replace(/"/g, '""')}"`).join(',') + '\n'
      })
      // 下载
      const blob = new Blob([csv], { type: 'text/csv;charset=utf-8;' })
      const link = document.createElement('a')
      link.href = URL.createObjectURL(blob)
      link.download = `export_${Date.now()}.csv`
      link.click()
      URL.revokeObjectURL(link.href)
      this.$emit('export', data)
    }
  }
}
</script>
